module.exports = __webpack_public_path__ + "static/media/attendanceSettings.0e354f79.svg";